export default __webpack_public_path__ + "static/media/gg-idle-cropped.a67edaa9.png";